/* eslint-disable react/display-name */
// * You should NOT edit this file directly. Read CONTRIBUTING.md for more information on creating icons
import { __assign } from "tslib";
import React from 'react';
import { forwardRef } from '../../helpers/forwardRef';
import { BaseIcon } from '../../internal/BaseIcon';
export var People1CheckIcon24Solid = forwardRef('People1CheckIcon24Solid', function (props, ref) {
    return (React.createElement(BaseIcon, __assign({ ref: ref, viewBoxSize: 24 }, props),
        React.createElement("path", { d: "M18 7A6 6 0 1 1 6 7a6 6 0 0 1 12 0Z" }),
        React.createElement("path", { d: "m16.05 18 2.597-2.596C16.486 14.137 13.762 14 12 14c-2.985 0-8.736.395-9.821 6.01C1.969 21.093 2.895 22 4 22h6.127a3.501 3.501 0 0 1 5.348-4.475l.525.525V18h.05Z" }),
        React.createElement("path", { d: "M23.634 17.134a1.25 1.25 0 0 0-1.768-1.768L16 21.232l-2.116-2.116a1.25 1.25 0 0 0-1.768 1.768l2.293 2.293a2.25 2.25 0 0 0 3.182 0l6.043-6.043Z" })));
});
